export default __webpack_public_path__ + "static/media/gmts-kun_icon_moji_tabetai_20px.cc0f8214.png";